import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import TaskCard from './TaskCard';
import "./index.css";

const DraggableBox = ({ value, onChange = () => { } }) => {
    const [columns, setColumns] = useState(value);

    useEffect(() => {
        setColumns(value)
    }, [JSON?.stringify(value)])

    const onDragEnd = (result) => {
        if (!result.destination) return;
        const { source, destination } = result;
        if (source.droppableId !== destination.droppableId) {
            const sourceColumn = columns[source.droppableId];
            const destColumn = columns[destination.droppableId];
            const sourceItems = [...sourceColumn.items];
            const destItems = [...destColumn.items];
            const [removed] = sourceItems.splice(source.index, 1);
            destItems.splice(destination.index, 0, removed);
            onChange({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems,
                },
                [destination.droppableId]: {
                    ...destColumn,
                    items: destItems,
                },
            });
        } else {
            const column = columns[source.droppableId];
            const copiedItems = [...column.items];
            const [removed] = copiedItems.splice(source.index, 1);
            copiedItems.splice(destination.index, 0, removed);
            onChange({
                ...columns,
                [source.droppableId]: {
                    ...column,
                    items: copiedItems,
                },
            });
        }
    };

    return (
        <DragDropContext
            onDragEnd={(result) => onDragEnd(result)}
        >
            <div className='d-flex'>
                <div className='drag-column'>
                    {Object.entries(columns).map(([columnId, column], index) => {
                        return (
                            <Droppable key={columnId} droppableId={columnId}>
                                {(provided, snapshot) => (
                                    <div className='drag-box'
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                    >
                                        <div className='drag-title'>{column.title}</div>
                                        <div className='drag-list'>
                                            {column.items.map((item, index) => (
                                                <TaskCard key={item?.id || item?.title || index} item={item} index={index} />
                                            ))}
                                            {provided.placeholder}
                                        </div>

                                    </div>
                                )}
                            </Droppable>
                        );
                    })}
                </div>
            </div>
        </DragDropContext>
    );
};

export default DraggableBox;
